export default [
  { path: '/test', component: '@/pages/testPage/test', title: 'test' },
  {
    path: '/test/bridge',
    component: '@/pages/testPage/bridge',
    title: 'bridge',
  },
  {
    path: '/test/counter',
    component: '@/pages/testPage/counter',
    title: 'counter',
  },
  {
    path: '/test/styles',
    component: '@/pages/testPage/styles',
    title: 'styles',
  },
];
